import React from 'react'
import SuperUserTxnPageUI from '../../../templates/SuperUserTxnPageUI.js'
import FixedDepositListUI from '../../../components/superUser/nodalTxn/FixedDepositListUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'

const CurrFixedDepositListPageUI = ({
  context, accountNumber, onRefreshClick,
  fdTransferList, totals, fdTransactions, fdMonthlyTotals, fdTxnList,
  financialYear, financialYearList, onFinancialYearChange
}) =>
  <SuperUserTxnPageUI context={context} className='pg_su_fd' topnav='transactions' backLink='/su/accounts'
    headerText='Accounts' centered={!totals} page='4412fd'
  >
    {
      (!totals) &&
      <SpinnerComponentUI />
    }
    {
      totals &&
      <FixedDepositListUI
        context={context}
        accountNumber={accountNumber}
        fdTransferList={fdTransferList}
        fdTransactions={fdTransactions}
        fdTxnList={fdTxnList}
        totals={totals}
        fdMonthlyTotals={fdMonthlyTotals}
        onRefreshClick={onRefreshClick}
        //
        financialYear={financialYear}
        financialYearList={financialYearList}
        onFinancialYearChange={onFinancialYearChange}
      />
    }

  </SuperUserTxnPageUI>

export default CurrFixedDepositListPageUI
